import axios from '../http'

function query(data) {
    return axios.post('/basedata/leader/query', data);
}


function get(id) {
    return axios.get('/basedata/leader/get?id=' + id);
}


export default {
    query,
    get
}